import React from "react";
import styles from "./customer-support.module.css";
import {
  WechatOutlined,
  MailOutlined,
  PhoneOutlined,
  GlobalOutlined,
  CopyOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import RoutesConstant from "../../../constants/routes";

const CustomerSupport = () => {
  const navigate = useNavigate();

  const contactTypes = [
    {
      type: "Call Support",
      description: "Talk to our support team directly for immediate assistance",
      icon: <PhoneOutlined />,
      text: "+91 98745 61230",
      color: "blue",
    },
    {
      type: "Chat with Us",
      description: "Get instant help through live chat with our support agents",
      icon: <WechatOutlined />,
      action: "Start Chat",
      onClick: () => navigate(RoutesConstant.SUPPORT_CHAT),
      color: "orange",
    },
    {
      type: "Visit Website",
      description: "Browse tutorials, help center, and self-service resources",
      icon: <GlobalOutlined />,
      action: "Visit Now",
      onClick: () => {},
      color: "purple",
    },
    {
      type: "Email Us",
      description: "Drop us an email and we’ll get back to you",
      icon: <MailOutlined />,
      text: "info@nextzenminds.tech",
      color: "green",
    },
  ];

  return (
    <div className={styles["customer-support-section"]}>
      <div className={styles["customer-support-header"]}>
        <h2>How can we help you?</h2>
        <p>
          We're here to support your journey. Get instant help through multiple
          channels - call, chat, or email us directly.
        </p>
      </div>

      <div className={styles["customer-support-list"]}>
        {contactTypes.map((item, index) => (
          <div
            key={index}
            className={`${styles["customer-support-card"]} ${styles[item.color]}`}
          >
            <div className={styles["customer-support-icon"]}>{item?.icon}</div>
            <h3>{item?.type}</h3>
            <p className={styles["customer-support-desc"]}>
              {item?.description}
            </p>
            {item?.action ? (
              <button 
                className={styles["customer-support-btn"]}
                onClick={item?.onClick}
              >
                {item?.action} →
              </button>
            ) : item?.text ? (
              <div className={styles["customer-support-text"]}>
                <span>{item?.text}</span>
                <CopyOutlined
                  className={styles["copy-icon"]}
                  onClick={(e) => {
                    e.stopPropagation();
                    navigator.clipboard.writeText(item?.text);
                  }}
                />
              </div>
            ) : null}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomerSupport;
